import { cn, Icon, Text, useSidebar } from '@mntn/ui-components'
import { Button } from '@/components/shared'
import { useFilter } from '../context/filter-context'

interface FilterTriggerButtonProps {
  label?: string
  className?: string
}

export const FilterTriggerButton = ({ label = 'Filter', className }: FilterTriggerButtonProps) => {
  const { activeFiltersCount } = useFilter()
  const { open, setOpen } = useSidebar()

  const handleClick = () => {
    if (!open) {
      setOpen(true)
    }
  }

  return (
    <Button
      size="small"
      onClick={handleClick}
      disabled={open}
      variant={open ? 'active' : 'inactive'}
      className={cn(
        'h-[46px] px-6 flex items-center gap-2 rounded-xs border-0 transition-colors',
        open && 'cursor-default',
        className,
      )}
    >
      <Icon name="SlidersHorizontal" className="text-header-inverse" />
      <Text variant="base-sb" className="text-header-inverse">
        {label} {activeFiltersCount > 0 && `(${activeFiltersCount})`}
      </Text>
    </Button>
  )
}
